<template>
  <div class="tw-pane-lease">
    <div class="pane-title">申請案件基本資料</div>
    <div class="pane-top">
      <div class="top-left">
        <div>
          <div>{{message.ActivityTitle}}</div>
        </div>
        <div>
          <div>
            <span>開始時間(含場佈)</span>
            <span>{{message.BeginTime | dateToDate2}} 起</span>
          </div>
          <div>
            <span>結束開始(含撤場)</span>
            <span>{{message.EndTime | dateToDate2}} 止</span>
          </div>
          <div>
            <span>活動開始</span>
            <span>{{message.AcBeginTime | dateToDate2}} 起</span>
          </div>
          <div>
            <span>活動結束</span>
            <span>{{message.AcEndTime | dateToDate2}} 止</span>
          </div>
        </div>
        <div>
          <div>
            <span>使用單位</span>
            <span>{{message.LendingContact.Dept}}</span>
          </div>
          <div>
            <span>聯絡人員</span>
            <span>{{message.LendingContact.Name}}</span>
          </div>
          <div>
            <span>電話</span>
            <span>{{message.LendingContact.Phone}}</span>
          </div>
        </div>
        <div>
          <div>
            <span>活動地點</span>
            <span>{{message.LendingSite}}</span>
          </div>
          <div>
            <span>填表日期</span>
            <span>{{message.OrderCode | dateToDate3}}</span>
          </div>
          <div>
            <span>活動內容</span>
            <span>{{message.ActivityContent}}</span>
          </div>
          <div>
            <span>備註</span>
            <span>{{message.Remark}}</span>
          </div>
          <div v-if="message.Attached.length">
            <span>附件</span>
            <div>
              <div v-for="item in message.Attached" :key="item.ID">
                <span
                  class="remove-attached iconfont icon-guanbi"
                  @click="RemoveSpecifyAttached(item.ID)"
                ></span>
                <span class="attached" @click="DownloadSpecifyAttached(item.ID)">{{item.Name}}</span>
              </div>
              <div class="attached" @click="DownloadAllAttached">點我下載全部</div>
            </div>
          </div>
        </div>
      </div>
      <div class="top-right">
        <div v-for="item in question" :key="item.QuestionID">
          <div>
            <span class="select" :class="{active: item.Agreed}" @click="item.Agreed = !item.Agreed"></span>
            <span>{{item.Order}}. {{item.Question}}</span>
          </div>
          <input type="text" placeholder="備註" v-model="item.Remark" />
        </div>
      </div>
    </div>
    <div class="pane-bottom">
      <div class="bottom-title">審查結果</div>
      <div class="bottom-content">
        <div class="content-left">
          <div class="left-radio">
            <span class="radio" :class="{active: reviewResultOKClass}" @click="reviewResult = true"></span>
            <span>同意</span>
          </div>
          <div class="left-form">
            <div>
              <div>
                <span
                  class="radio"
                  :class="{active: freeType.government}"
                  @click="freeType.government = !freeType.government; freeType.coOrganizer = false; freeType.nonGovernment = false;"
                ></span>
                <span class="len">本府機關免費</span>
              </div>
              <div>
                <div>
                  使用費
                  <input type="text" placeholder="新台幣" :disabled="isFree" v-model="Charge" /> 元
                </div>
              </div>
              <div>
                <span class="radio" :class="{active: freeType.government}" @click="ChangedFreeType"></span>
                <span>免費</span>
              </div>
            </div>
            <div>
              <div>
                <span
                  class="radio"
                  :class="{active: freeType.coOrganizer}"
                  @click="freeType.government = false; freeType.coOrganizer = !freeType.coOrganizer; freeType.nonGovernment = false;"
                ></span>
                <span class="len">本府機關協辦</span>
              </div>
              <div>
                <div>
                  保證金
                  <input type="text" placeholder="新台幣" v-model="Deposit" :disabled="isFree" /> 元
                </div>
              </div>
              <div>
                <span class="radio" :class="{active: freeType.government}" @click="ChangedFreeType"></span>
                <span>免費</span>
              </div>
            </div>
            <div>
              <div>
                <span
                  class="radio"
                  :class="{active: freeType.nonGovernment}"
                  @click="freeType.government = false; freeType.coOrganizer = false; freeType.nonGovernment = !freeType.nonGovernment;"
                ></span>
                <span class="len">非本府機關</span>
                <!-- <input type="text"> -->
              </div>
            </div>
            <div>
              <div>
                <span class="indent"></span>
                <span class="len">案件編號</span>
                <input type="text" v-model="CaseCode" />
              </div>
            </div>
          </div>
        </div>
        <div class="content-right">
          <div>
            <span
              class="radio"
              :class="{active: reviewResultNGClass}"
              @click="reviewResult = false"
            ></span>
            <span>不同意</span>
          </div>
          <textarea placeholder="審查結果備註" v-model="remark"></textarea>
        </div>
      </div>
      <div class="bottom-button">
        <tw-button title="送出" @click="SendVerifyOrder"></tw-button>
        <tw-button title="撤銷" @click="CancelOrder"></tw-button>
        <tw-button title="匯出" @click="ExportReviewResult"></tw-button>
        <tw-button title="離開" @click="leave"></tw-button>
      </div>
    </div>
  </div>
</template>

<script>
import TwButton from "../tw-btn";
import API from "../../api/index.js";
import { MessageBox } from "element-ui";

export default {
  data() {
    return {
      postData: null,
      Deposit: null,
      Charge: null,
      CaseCode: null,
      remark: "",
      // nicky
      reviewResult: null, // Agree/Disagree
      freeType: {
        government: false, // Government agency free
        coOrganizer: false, // Government agency co-organizer
        nonGovernment: false // Non-government agency
      }
    };
  },

  components: {
    TwButton
  },

  methods: {
    leave() {
      this.$parent.showPane = false;
    },
    getVerifyById(id) {
      this.$axios
        .get(API.siteVerify + "/" + id)
        .then(res => {
          this.postData = res.data;
          this.postData.ID = id;

          // nicky
          this.reviewResult = this.postData.Result;
          this.CaseCode = this.postData.CaseCode;
          this.Deposit = this.postData.Deposit;
          this.Charge = this.postData.Charge;
          this.remark = this.postData.Note;

          if (this.reviewResult === true) {
            switch (this.postData.Remark) {
              case "本府機關免費":
                this.freeType.government = true;
                break;
              case "本府機關協辦":
                this.freeType.coOrganizer = true;
                break;
              case "非本府機關":
                this.freeType.nonGovernment = true;
                break;
              default:
                this.freeType.government = true;
                break;
            }
          }
        })
        .catch(err => {
          console.log(err, "Error fetching approval data");
        });
    },
    // postVerify() {
    //   if (this.postData.Result) {
    //     this.postData.Remark = null;
    //     this.postData.Charge = this.Charge;
    //     this.postData.Deposit = this.Deposit;
    //     this.postData.CaseCode = this.CaseCode;
    //   } else {
    //     this.postData.Remark = this.remark;
    //     this.postData.Charge = null;
    //     this.postData.Deposit = null;
    //   }
    //   //   console.log(this.postData, "000000000000000000000000000");
    //   this.$axios
    //     .post(API.siteVerify, this.postData)
    //     .then(res => {
    //       this.$alert("簽核成功", "提示");
    //       this.leave();
    //     })
    //     .catch(err => {
    //       this.$alert("簽核失敗", "提示");
    //     });
    // },
    // send() {
    //   this.postVerify();
    // },
    // agree() {
    //   this.$refs.agreeRadio.classList.add("active");
    //   this.$refs.unagreeRadio.classList.remove("active");
    //   this.postData.Result = true;
    // },
    // unAgree() {
    //   this.$refs.agreeRadio.classList.remove("active");
    //   this.$refs.unagreeRadio.classList.add("active");
    //   this.postData.Result = false;
    // },
    // activeQuestion(e, item) {
    //   e.target.classList.toggle("active");
    //   item.Agreed = !item.Agreed;
    // },
    // judge(e, type) {
    //   if (e.target.classList.contains("active")) {
    //     //取消選中
    //     this[type] = null;
    //   } else {
    //     //選中
    //     this[type] = null;
    //   }
    //   e.target.classList.toggle("active");
    // },
    // styleJudge(e) {
    //   e.target.classList.toggle("active");
    // },
    // nicky
    ChangedFreeType() {
      if (this.isFree) {
        this.freeType.government = false;
        this.freeType.coOrganizer = false;
        this.freeType.nonGovernment = false;
      } else {
        this.freeType.government = !this.freeType.government;
        this.freeType.coOrganizer = false;
        this.freeType.nonGovernment = false;
      }
    },
    SendVerifyOrder() {
      if (this.reviewResult === null) {
        this.$alert("請選擇審查結果", "提示", {
          confirmButtonText: "確定"
        });
        return;
      }
      if (
        this.reviewResult === true &&
        this.isFree === false &&
        (this.Deposit === null || this.Charge === null)
      ) {
        this.$alert("請勾選免費或填寫使用費與保證金", "提示", {
          confirmButtonText: "確定"
        });
        return;
      }

      if (this.reviewResult) {
        this.postData.Charge = this.freeType.government ? null : this.Charge;
        this.postData.Deposit = this.freeType.government ? null : this.Deposit;
        this.postData.CaseCode = this.CaseCode;
        this.postData.Remark = this.freeType.government
          ? "本府機關免費"
          : this.freeType.coOrganizer
          ? "本府機關協辦"
          : "非本府機關";
      } else {
        this.postData.Charge = null;
        this.postData.Deposit = null;
        this.postData.CaseCode = null;
        this.postData.Remark = null;
      }
      this.postData.Note = this.remark;
      this.postData.Result = this.reviewResult;
      // console.log(this.postData);

      this.$axios
        .post(API.siteVerify, this.postData)
        .then(res => {
          this.$store.commit("SetLendingSiteOrderListStatus", {
            id: this.postData.ID,
            statusValue: this.reviewResult ? "T" : "F",
            status: this.reviewResult ? "已處理" : "駁回",
            charge: this.isFree ? 0 : this.Charge
          });

          this.$alert("簽核成功", "提示", {
            confirmButtonText: "確定"
          });
          this.leave();
        })
        .catch(err => {
          this.$alert("簽核失敗", "提示", {
            confirmButtonText: "確定"
          });
        });
    },
    CancelOrder() {
      MessageBox.confirm("請確認是否撤銷此申請", "是否撤銷", {
        confirmButtonText: "確定",
        cancelButtonText: "取消"
      })
        .then(() => {
          let url = API.getLease + this.postData.ID;
          this.$axios
            .delete(url)
            .then(res => {
              this.$store.commit("SetLendingSiteOrderListStatus", {
                id: this.postData.ID,
                statusValue: "D",
                status: "撤銷",
                charge: null
              });

              this.$alert("撤銷成功", "提示", {
                confirmButtonText: "確定"
              });
            })
            .catch(err => {
              this.$alert("撤銷成功", "提示", {
                confirmButtonText: "確定"
              });
            });
        })
        .catch(() => {});
      return;
    },
    ExportReviewResult() {
      // let src = "api/export-r/review/" + this.postData.ID; // 市府內
      let src = "export-r/review/" + this.postData.ID;
      // console.log(src);
      var eleLink = document.createElement("a");
      eleLink.download = src;
      eleLink.style.display = "none";
      eleLink.href = src;
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink);
    },
    DownloadAllAttached() {
      let src = "download/review_allattached/" + this.postData.ID;
      // let src = "download/review_allattached/" + 5272;
      var eleLink = document.createElement("a");
      eleLink.download = src;
      eleLink.style.display = "none";
      eleLink.href = src;
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink);
    },
    DownloadSpecifyAttached(id) {
      let src = "download/review_specifyattached/" + id;
      // let src = "download/review_specifyattached/" + id;
      var eleLink = document.createElement("a");
      eleLink.download = src;
      eleLink.style.display = "none";
      eleLink.href = src;
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink);
    },
    RemoveSpecifyAttached(id) {
      this.$store.commit("RemoveLendingReviewPageAttached", {
        ID: id
      });

      this.$axios
        .delete(API.deletelendingAttached + id)
        .then(res => {
          this.$alert("刪除成功", "提示", {
            confirmButtonText: "確定"
          });
        })
        .catch(err => {
          // this.$alert("刪除失敗", "提示");
        });
    }
    // NumberInputHandler(event) {
    //   this.charge = this.charge.replace(/[^\d]/g, "");
    //   this.depsoit = this.depsoit.replace(/[^\d]/g, "");
    // }
  },

  computed: {
    message() {
      return this.$store.state.signedData;
    },
    question() {
      if (this.postData) {
        return this.postData.Question;
      }
      return [];
    },
    isFree() {
      return this.freeType.government;
    },
    reviewResultOKClass() {
      if (this.reviewResult === null) {
        return false;
      } else {
        return this.reviewResult;
      }
    },
    reviewResultNGClass() {
      if (this.reviewResult === null) {
        return false;
      } else {
        return !this.reviewResult;
      }
    }
  },

  filters: {
    dateToDate(date) {
      if (!date) return;
      const _date = date.split("T")[0];
      const __date = _date.split("-");
      __date[0] = __date[0] - 1911;
      return __date[0] + "年" + __date[1] + "月" + __date[2] + "日";
    },
    dateToDate2(date) {
      if (!date) return;
      let dateobj = new Date(date);

      let _day = dateobj.getDay(),
        _h = ("0" + dateobj.getHours()).slice(-2),
        _m = ("0" + dateobj.getMinutes()).slice(-2),
        __day;
      switch (_day) {
        case 1:
          __day = "星期一";
          break;
        case 2:
          __day = "星期二";
          break;
        case 3:
          __day = "星期三";
          break;
        case 4:
          __day = "星期四";
          break;
        case 5:
          __day = "星期五";
          break;
        case 6:
          __day = "星期六";
          break;
        case 0:
          __day = "星期天";
          break;
      }
      const _date = date.split("T")[0];
      const __date = _date.split("-");
      __date[0] = __date[0] - 1911;

      return (
        __date[0] +
        "年" +
        __date[1] +
        "月" +
        __date[2] +
        "日" +
        " " +
        __day +
        " " +
        _h +
        ":" +
        _m
      );
    },
    dateToDate3(date) {
      if (!date) return;
      const _date = date.substr(3, 6);
      const _y = "20" + _date.substr(0, 2) - 1911,
        _m = _date.substr(2, 2),
        _d = _date.substr(4, 2);
      return _y + "年" + _m + "月" + _d + "日";
    }
  },

  created() {
    const data = this.$store.state.signedData;
    this.getVerifyById(data.ID);
  }
};
</script>


<style lang="less" scoped>
.tw-pane-lease {
  width: 100%;
  height: auto;
  min-height: 100%;
  border-radius: 3.5rem;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #dfe6e9;
  padding: 30px 50px;
  display: flex;
  flex-direction: column;
}
.pane-title {
  font-weight: bold;
  font-size: 1.5rem;
  height: 2rem;
  line-height: 2rem;
}
.pane-top {
  display: flex;
  flex: 1;

  // padding-right: 1rem;
  .top-left {
    width: 40%;
    & > div {
      height: auto;
      & > div {
        display: flex;
        height: auto;
        & > span:nth-child(1) {
          // display: inline-block;
          flex: 1;
          width: 150px;
        }
        & > span:nth-child(2),
        & > div {
          // display: flex;
          flex: 4;
        }
      }
    }
    & > div:nth-child(1) {
      height: 50px;
      font-size: 16px;
    }
    .attached {
      color: #1b2d4d;
      cursor: pointer;
      &:hover {
        color: #6098ff;
      }
      &:last-of-type {
        margin-bottom: 1rem;
      }
    }
    .remove-attached {
      font-size: 1rem;
      margin-right: 0.5rem;
      color: #814747;
      &:hover {
        color: #ff7e94;
      }
    }
  }
  .top-right {
    width: 60%;
    & > div {
      height: 35px;
      display: flex;
      & > div {
        width: 40%;
        .select {
          margin-right: 5px;
        }
      }
      & > input {
        height: 2rem;
        padding: 0 10px;
        border-radius: 8px;
        flex: 1;
      }
    }
  }
}
.pane-bottom {
  background-color: #fff;
  border-radius: 3.5rem;
  .bottom-title {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
  .bottom-content {
    display: flex;
    padding: 0 100px;
    & > div {
      flex: 1;
      display: flex;
    }
    .content-left {
      flex: 11;
      border-right: 1px solid #000;
      .left-radio {
        width: 70px;
        & > span {
          vertical-align: middle;
        }
      }
      .left-form {
        flex: 1;
        & > div {
          display: flex;
          height: 2.4rem;
          & > div:nth-child(1) {
            width: 50%;
            input {
              width: 50%;
              height: 24px;
              background-color: #efefef;
              text-indent: 5px;
              border-radius: 8px;
            }
          }
          & > div:nth-child(2) {
            width: 35%;
            input {
              width: 65%;
              height: 24px;
              background-color: #efefef;
              text-indent: 5px;
              border-radius: 8px;
            }
          }
          & > div:nth-child(3) {
            width: 15%;
          }
        }
      }
    }
    .content-right {
      flex: 13;
      & > div {
        border-right: 1px solid #000;
        width: 150px;
        padding: 0px 30px;
      }
      & > textarea {
        border-radius: 10px;
        margin-left: 45px;
        padding: 10px;
        resize: none;
        width: 100%;
        background-color: #efefef;
      }
    }
  }
  .bottom-button {
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    & > div {
      margin: 0 10px;
    }
  }
}
.select {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background-color: #fff;
  cursor: pointer;
}
.radio {
  display: inline-block;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 0.4rem;
  background-color: #dfe6e9;
  cursor: pointer;
}
.active {
  background-color: #000;
}
.indent {
  display: inline-block;
  width: 1.2rem;
  height: 1.2rem;
}
.len {
  display: inline-block;
  width: 90px;
}
</style>




// WEBPACK FOOTER //
// src/components/lease/leaseDialog.vue